import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BankAccountsPage.ConnectionCanceledPopup', {
    close: 'Close',
    learnMore: 'Learn more',
    unableToEstablish: 'Bank account connection cancelled',
    thereWasAnIssue: 'Unable to connect to your bank account.',
});
